module.exports = __webpack_public_path__ + "img/pet-friendly-no.2ede4c5d.svg";